import { Environment as EnvironmentEnum } from '@gea/digital-ui-lib';
import { InjectionToken } from '@angular/core';

export interface Environment {
  production: boolean;
  statusTimeoutMinutes: number; // Machine offline threshold in minutes
}

//Environment Configurations are stored in the asset folder
export type EnvironmentConfiguration = {
  name?: EnvironmentEnum;
  oAuth: {
    redirectURL: string;
    postLogoutRedirectURL: string;
    clientId: string;
    authorityDomain: string;
    authority: string;
    passwordResetAuthority: string;
  };
  baseURL: string;
  storageURL: string;
  localizationStorageURL: string;
  iconStorageURL?: string;
  portal: {
    baseURL?: string;
    redirectURL: string;
  };
  advance?: {
    baseURL?: string;
    redirectURL?: string;
  };
  serviceCall: {
    baseURL?: string;
  };
  cookielawId?: string;
};

export const ENVIRONMENT_CONFIG = new InjectionToken<Environment>(
  'Environment_Configuration',
);
